export interface ContactPayload {
  name: string;
  email: string;
  phone: string;
  country: string;
  company: string;
  service: string;
  message: string;
  recaptcha_token: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
}

export const sendContactForm = async (payload: ContactPayload): Promise<ContactResponse> => {
  const API_URL = '/api/contact.php';

  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        message: errorData.message || 'Error en el servidor. Intente más tarde.',
      };
    }

    return await response.json();
  } catch (error) {
    console.error('Connection error:', error);
    return {
      success: false,
      message: 'No se pudo conectar con el servidor. Verifique su conexión.',
    };
  }
};
